<template>
  <div class="dynamic-form-detail-wrapper">
    <dynamic-form-wrapper
      :id="$route.params.id"
      viewType="dynamicFormDetail"
      :showHistory="true"
      :onBack="() => $router.go(-1)"
    ></dynamic-form-wrapper>
  </div>
</template>

<script>
import DynamicFormWrapper from "@/pages/checkModule/examine/components/dynamicFormWrapper.vue";
export default {
  name: "DynamicFormDetailWrapper",
  components: { DynamicFormWrapper },
};
</script>

<style lang="scss" scoped>
</style>